import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacyPageComponent } from './components/page/privacy-page.component';
import { PrivacyRoutingModule } from './privacy-routing.module';
import { MatGridListModule } from '@angular/material/grid-list';


@NgModule({
  declarations: [
	  PrivacyPageComponent,
  ],
  imports: [
    MatGridListModule,
    CommonModule,
    PrivacyRoutingModule
  ]
})
export class PrivacyModule { }
